import type { TagType } from "@/components/Tag/Tag";
import type { MembershipElectionRunStatus, MembershipElectionRunTriggerType } from "../types";

export const ELECTION_RUN_STATUS_LABELS: Record<MembershipElectionRunStatus, string> = {
  COMPLETED: "Completed",
  FAILED: "Failed",
  IN_PROGRESS: "In progress",
  PARTIAL_FAILURE: "Partial failure",
  PENDING: "Pending"
};

export const ELECTION_RUN_STATUS_TAG_TYPE: Record<MembershipElectionRunStatus, TagType> = {
  COMPLETED: "success",
  FAILED: "error",
  IN_PROGRESS: "information",
  PARTIAL_FAILURE: "warn",
  PENDING: "surface"
};

export const ELECTION_RUN_TRIGGER_LABELS: Record<MembershipElectionRunTriggerType, string> = {
  MANUAL: "Manual",
  SCHEDULED: "Scheduled"
};
